import React, { useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { CustomLogin } from '../components';
import LandingTopbar from './landing/LandingTopbar';
import BottomNavigation from '../navigation/BottomNavigation';
import TopNavigation from '../navigation/TopNavigation';
import { Toast } from 'primereact/toast';
import AuthService from '../security/AuthService';
import CustomAuthLayer from '../components/CustomAuthLayer';
import { useTranslation } from 'react-i18next';

export const Login = (props) => {
    const toast = useRef(null);
    const { t } = useTranslation();

    const renderButton = () => {

        return (
            <div className=" flex  pr-3 pb-3 w-12 justify-content-end">

                {!AuthService.isLoggedIn() &&
                    <Button icon="pi pi-user-edit" label={t('menu_membership')} className="p-button-rounded  p-button-secondary mr-2 mb-2 " text

                        onClick={() => props.history.push('/register')}></Button>
                }
            </div>
        )
    }

    return (
        <div className='root-landing'>
            <Toast ref={toast} />

            <div className="grid grid-nogutter surface-login-main p-2" >

                <TopNavigation {...props} toast={toast} />
                <BottomNavigation {...props} toast={toast} />

                <div className="container-fluid" style={{ maxWidth: 500 }}>
                    {AuthService.isLoggedIn() && <CustomAuthLayer {...props} toast={toast} />}
                    {!AuthService.isLoggedIn() && <CustomLogin {...props} toast={toast} />}
                    {renderButton()}

                </div>
            </div>
        </div>
    );
};
